/**
 * Список инноваций
 */
import { Pagination } from '@n3/ng-api-common';
import { InnovationShort } from './innovationShort.model';
export class InnovationList extends Pagination {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public items: InnovationShort[]; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.items = [];
        if (json.items) {
          for (const i in json.items) {
            if ( json.items.hasOwnProperty( i ) ) {
                this.items.push(new InnovationShort(json.items[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
